var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTerminaCon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_473_6021)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 44C9.84974 44 0 34.1503 0 22C0 9.84974 9.84974 0 22 0C34.1503 0 44 9.84974 44 22C44 34.1503 34.1503 44 22 44Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0077 18.9992C26.9372 18.9992 27.4019 18.9992 27.7685 19.1596C28.2573 19.3736 28.6457 19.7839 28.8482 20.3003C29 20.6877 29 21.1787 29 22.1608C29 23.1428 29 23.6338 28.8482 24.0212C28.6457 24.5376 28.2573 24.9479 27.7685 25.1618C27.4019 25.3223 26.0077 25.3223 26.0077 25.3223V18.9992Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0077 25.3223H18.0282C17.0987 25.3223 16.634 25.3223 16.2673 25.1618C15.7786 24.9479 15.3902 24.5376 15.1877 24.0212C15.0359 23.6338 15.0359 23.1428 15.0359 22.1608C15.0359 21.1787 15.0359 20.6877 15.1877 20.3003C15.3902 19.7839 15.7786 19.3736 16.2673 19.1596C16.634 18.9992 17.0987 18.9992 18.0282 18.9992C18.0282 18.9992 25.0782 18.9992 26.0077 18.9992M26.0077 25.3223C26.0077 25.3223 27.4019 25.3223 27.7685 25.1618C28.2573 24.9479 28.6457 24.5376 28.8482 24.0212C29 23.6338 29 23.1428 29 22.1608C29 21.1787 29 20.6877 28.8482 20.3003C28.6457 19.7839 28.2573 19.3736 27.7685 19.1596C27.4019 18.9992 26.9372 18.9992 26.0077 18.9992M26.0077 25.3223V18.9992",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_473_6021"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white",
    transform: "matrix(-1 0 0 1 44 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerminaCon);
export default __webpack_public_path__ + "static/media/TerminaCon.60245d9e3d82ae5af9b73ea83f741a2d.svg";
export { ForwardRef as ReactComponent };